import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { Breakpoints } from '@picsart/design-system/foundation/responsive';
import { hideScrollbars } from '@picsart/design-system/styleUtils/hideScrollbars';

const SLIDE_HEIGHT_MOBILE = 220;

const DESKTOP_VISIBLE_SLIDES = 3;
const SLIDE_GAP = Spacings.s8;
const DESKTOP_SLIDE_BASIS = `calc((100% - ${
  DESKTOP_VISIBLE_SLIDES - 1
} * ${SLIDE_GAP}) / ${DESKTOP_VISIBLE_SLIDES})`;

const useStyles = createUseStyles(
  {
    container: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      flexShrink: 0,
      gap: SLIDE_GAP,
      '--trending-slide-basis': '100%',
      [`@media (min-width: ${Breakpoints.md}px)`]: {
        '--trending-slide-basis': DESKTOP_SLIDE_BASIS,
      },
      paddingLeft: Spacings.s16,
      paddingRight: Spacings.s16,
      paddingBottom: Spacings.s12,
      scrollPaddingLeft: Spacings.s16,
      scrollPaddingRight: Spacings.s16,
      overflowX: 'auto',
      overflowY: 'hidden',
      overscrollBehaviorX: 'contain',
      scrollSnapType: 'x mandatory',
      WebkitOverflowScrolling: 'touch',
      ...hideScrollbars,
      [`@media (max-width: ${Breakpoints.xs - 1}px)`]: {
        paddingLeft: Spacings.s12,
        paddingRight: Spacings.s12,
        scrollPaddingLeft: Spacings.s12,
        scrollPaddingRight: Spacings.s12,
      },
    },
    slide: {
      width: '100%',
      flex: '0 0 var(--trending-slide-basis, 100%)',
      aspectRatio: '16 / 9',
      [`@media (max-width: ${Breakpoints.xs - 1}px)`]: {
        aspectRatio: 'auto',
        height: SLIDE_HEIGHT_MOBILE,
      },
    },
  },
  { name: 'trending-carousel' }
);

export default useStyles;
